<template>
    <section>
        <div class="board">
            <div class="bar">
                <b-icon icon="bar-chart" class="icon"></b-icon>
                <span v-if="reportOption === 1">สรุปยอดรายเดือน</span>
                <span v-if="reportOption === 2">สรุปยอดรายวัน</span>
            </div>
            <div class="content" v-if="initFormFilter">
                <div class="filter form mb-5" v-if="reportOption === 2">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-lg-4">
                            <div class="field">
                                <label>เดือน</label>
                                <dropdown
                                    v-model="formDailyChart.month"
                                    placeholder="-- เลือกเดือน --"
                                    :options="option.month"
                                    :classes="{ input: 'input-field' }"
                                    @change="loadSaleData(reportOption)"
                                ></dropdown>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-lg-4">
                            <div class="field">
                                <label>ปี</label>
                                <dropdown
                                    v-model="formDailyChart.year"
                                    placeholder="-- เลือกปี --"
                                    :options="option.year"
                                    :classes="{ input: 'input-field' }"
                                    @change="loadSaleData(reportOption)"
                                ></dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <template v-if="!isShowNetworkError">
                    <line-chart
                        v-if="saleData"
                        :chartData="saleData.chartData" 
                        :options="saleData.chartOption"
                        class="mb-5">
                    </line-chart>

                    <perfect-scrollbar v-if="tableData">
                        <table>
                            <thead>
                                <tr>
                                    <th v-for="(header, headerIndex) in tableData.header" :key="headerIndex" class="text-center" :class="{ 'title-column': headerIndex === 0 }">{{ header }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(data, dataIndex) in tableData.data" :key="dataIndex">
                                    <td v-for="(column, columnIndex) in data" :key="columnIndex" class="text-center" :class="{ 'title-column': columnIndex === 0 }">{{ column }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </perfect-scrollbar>
                </template>
                <template v-else>
                    <div class="no-data">
                        <b-icon icon="exclamation-diamond"></b-icon>
                        <span>ข้อมูลส่วนต้องใช้การเชื่อมต่ออินเทอร์เน็ต โปรดตรวจสอบการเชื่อมต่อของอุปกรณ์ที่ท่านใช้</span>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>

<script>
import OptionMonth from '@/database/staticOption/Month';
import LineChart from '@/components/chart/Line';
import Helper from '@/resources/Helper';

export default {
    components: {
        LineChart
    },
    data() {
        return {
            isLoading: false,
            isShowNetworkError: false,
            saleData: null,
            tableData: null,
            lineColor: [ '#8DC2F7', '#CBB79B' ],
            formDailyChart: this.initFormFilter(),
            option: {
                month: [],
                year: []
            }
        }
    },
    props: {
        reportOption: Number
    },
    watch: {
        reportOption(value) {
            this.loadSaleData(value);
        }
    },
    mounted() {
        this.initOptionData();
        this.loadSaleData(this.reportOption);
    },
    methods: {
        initFormFilter() {
            const today = new Date();

            return {
                month: today.getMonth() + 1,
                year: today.getFullYear()
            };
        },
        initOptionData() {
            const today = new Date();
            const currentYear = today.getFullYear();
            const yearList = [];
            const startYear = 2021;

            yearList.push({ id: startYear, name: startYear },);

            for (let index = 1; index < currentYear - startYear; index++) {
                const optionYear = startYear + 1;
                yearList.push({ id: optionYear, name: optionYear});
            }

            this.option.month = OptionMonth.option;
            this.option.year = yearList;
        },
        async loadSaleData(reportOption) {
            let loadData = null;
            this.saleData = null;
            this.isShowNetworkError = false;

            switch (reportOption) {
                case 1:
                    loadData = await this.loadMonthlyData();

                    this.saleData = this.chartMonthly(loadData);
                    break;

                case 2:
                    loadData = await this.loadDailyData();

                    this.saleData = await this.chartDaily(loadData);
                    break;
            }

            if (loadData.table) {
                this.tableData = loadData.table;
            }

            if (!this.saleData) {
                this.isShowNetworkError = true;
            }
        },
        async loadMonthlyData() {
            this.saleData = null;
            this.isLoading = true;
            const result = await Helper.postAPI(Helper.getApiUrl(), '/api/dashboard/chart-monthly-report', {});
            this.isLoading = false;

            if (result) {
                return result.data;
            } else {
                return null;
            }
        },
        async loadDailyData() {
            this.saleData = null;
            this.isLoading = true;
            const result = await Helper.postAPI(Helper.getApiUrl(), '/api/dashboard/chart-daily-report', this.formDailyChart);
            this.isLoading = false;

            if (result) {
                return result.data;
            } else {
                return null;
            }
        },
        getChartDataset() {
            return {
                label: '',
                fill: false,
                borderColor: '',
                borderWidth: 1,
                tension: 0,
                data: []
            }
        },
        chartMonthly(data) {
            const resultDataSets = [];
            const reportData = data.chart;

            if (reportData) {
                for (let index = 0; index < reportData.info.length; index++) {
                    const dataSet = this.getChartDataset();
                    dataSet.label = reportData.info[index].text;
                    dataSet.borderColor = this.lineColor[index];
                    dataSet.data = reportData.info[index].data;

                    resultDataSets.push(dataSet);
                }

                return {
                    chartData: {
                        labels: reportData.labels,
                        datasets: resultDataSets,
                    },
                    chartOption: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                },
                                gridLines: {
                                    display: true
                                }
                            }],
                            xAxes: [{
                                gridLines: {
                                    display: false
                                }
                            }]
                        },
                        legend: {
                            display: true,
                            labels: {
                                fontColor: '#ffffff'
                            }
                        },
                        responsive: true,
                        maintainAspectRatio: false
                    }
                }
            }

            return null;
        },
        chartDaily(data) {
            const resultDataSets = [];
            const reportData = data.chart;

            if (reportData) {
                for (let index = 0; index < reportData.info.length; index++) {
                    const dataSet = this.getChartDataset();
                    dataSet.label = reportData.info[index].text;
                    dataSet.borderColor = this.lineColor[index];
                    dataSet.data = reportData.info[index].data;

                    resultDataSets.push(dataSet);
                }

                return {
                    chartData: {
                        labels: reportData.labels,
                        datasets: resultDataSets,
                    },
                    chartOption: {
                        scales: {
                            yAxes: [{
                                ticks: {
                                    beginAtZero: true
                                },
                                gridLines: {
                                    display: true
                                }
                            }],
                            xAxes: [{
                                gridLines: {
                                    display: false
                                }
                            }]
                        },
                        legend: {
                            display: true,
                            labels: {
                                fontColor: '#ffffff'
                            }
                        },
                        responsive: true,
                        maintainAspectRatio: false
                    }
                }
            }

            return null;
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/Variable.scss';

.no-data {
    padding: 100px 20px;
}

table {
    .title-column {
        width: 90px;
    }
}
</style>